import { useParams } from 'react-router'
import { AssignmentDetailProvider } from './context/AssignmentDetailProvider'
import { AssignmentDetailPageContent } from './AssignmentDetailPageContent'
import { Outlet } from 'react-router-dom'

export const AssignmentDetailPage = () => {
  const { assignmentId: assignmentIdParam } = useParams<{
    assignmentId: string
  }>()
  const assignmentId = assignmentIdParam ? Number(assignmentIdParam) : undefined

  return (
    <AssignmentDetailProvider assignmentId={assignmentId}>
      <AssignmentDetailPageContent>
        <Outlet />
      </AssignmentDetailPageContent>
    </AssignmentDetailProvider>
  )
}
